import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map, tap, shareReplay } from 'rxjs/operators';
import { trigger, transition, useAnimation } from '@angular/animations';
import { slideInDown, fadeInUp } from 'ng-animate';
@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  animations: [
    trigger('slideInDown', [transition('* => *', useAnimation(slideInDown))]),
    trigger('fadeInUp', [transition('* => *', useAnimation(fadeInUp))])
  ]
})
export class ContactComponent implements OnInit {
  slideInDown
  fadeInUp
  constructor(private breakpointObserver: BreakpointObserver) { }

  ngOnInit(): void {
    this.isHandset$.subscribe()
  }
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      tap(isHandset => {
        if (isHandset) {
          const flexItem = document.getElementById("flex-item")
          flexItem.classList.remove('flex-item')
          flexItem.classList.add('flex-item-mobile')
        } else {
          const flexItem = document.getElementById("flex-item")
          flexItem.classList.remove('flex-item-mobile')
          flexItem.classList.add('flex-item')
        }
      }),
      shareReplay(),

    );

}
